export const SummaryStatisticsTableCell = ({
  label,
  value,
  isLoading = false,
}: React.PropsWithChildren<{ label: string; value: React.ReactNode; isLoading?: boolean }>) => {
  return (
    <div className="bg-background-secondary flex flex-col justify-between gap-2 rounded-lg p-3 sm:flex-row sm:gap-0 md:p-6">
      {isLoading ? (
        <div className="bg-skeleton-primary w-full rounded-sm text-transparent">.</div>
      ) : (
        <>
          <span
            className={`text-text-primary font-inter text-start truncate text-[17px] text-lg font-semibold`}
          >
            {label}
          </span>
          <span className={`text-brand-primary text-sm font-semibold sm:text-xl`}>{value}</span>
        </>
      )}
    </div>
  )
}
